export enum Align {
  RIGHT = 'right',
  CENTER = 'center',
  LEFT = 'left',
}
